
import {Component, Vue, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'store-locator',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  private isLoading: boolean = false;
  private storeResult = null;
  private headerMap = null;
  private currentStore = null;
  private error = null;

  private get searchStoreValue(): string {
    return this.$store.getters['StoreLocator/searchStoreValue'];
  }

  private get storesInRange(): object[] {
    return (this.storeResult || []).filter((store: object) => store['distance'] <= 200)
  }

  private async drawMap(): Promise<void> {
    document.getElementById('map').style.display = 'block';
    this.headerMap = new google.maps.Map(document.getElementById('map'), {
      center: { lat: 52.370216, lng: 4.895168 },
      scrollwheel: false,
      zoom: 7,
      disableDefaultUI: true
    });
  }

  private async drawMapMarkers(stores: object[]): Promise<void> {
    stores.forEach(store => {
      if (store['distance'] > 200) {
        return;
      }

      new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(store['latitude']), parseFloat(store['longitude'])),
        title: store['city'],
        map: this.headerMap,
        icon: '/area/web/default/assets/images/marker.png'
      });
    });
  }

  @Watch('searchStoreValue')
  private async handleStoreValue(): Promise<void> {
    this.isLoading = true;

    const postcode = this.searchStoreValue.replace(/\s/g, '');

    try {
      const {data} = await this.$solarClient.get(`api/store/closest?query=${postcode}&limit=10`);

      if ( ! data.data) {
        this.storeResult = null;
        this.isLoading = false;
        return;
      }

      if (data.data == 'location not found') {
        this.isLoading = false;
        this.storeResult = null;
        this.error = 'Geen resultaat gevonden.';
        document.getElementById('map').style.display = 'none';
        return;
      }

      this.storeResult = data.data;

      this.error = null;
      this.currentStore = this.searchStoreValue;
    } catch (e) {
      this.storeResult = null;
    } finally {
      this.isLoading = false;
    }

    if (null !== this.headerMap) {
      await this.drawMap();
      await this.drawMapMarkers(this.storeResult || []);
    }
  }
}
